import { apiClient } from './api';

export interface DriverLocation {
  id: number;
  driver_id: number;
  driver_name: string | null;
  delivery_route_id: number | null;
  route_name: string | null;
  latitude: number;
  longitude: number;
  accuracy_meters: number | null;
  heading_degrees: number | null;
  speed_kmh: number | null;
  captured_at: string;
}

export interface RecordLocationInput {
  delivery_route_id?: number;
  latitude: number;
  longitude: number;
  accuracy_meters?: number;
  heading_degrees?: number;
  speed_kmh?: number;
  captured_at?: string;
}

function unwrapList<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (Array.isArray(raw?.data)) return raw.data as T[];
  return [];
}

export async function recordLocation(input: RecordLocationInput): Promise<DriverLocation> {
  return apiClient.post<DriverLocation>('/driver-locations', input);
}

export async function getLiveLocations(staleMinutes: number = 15): Promise<DriverLocation[]> {
  const raw = await apiClient.get<any>('/driver-locations/live', { staleMinutes });
  return unwrapList<DriverLocation>(raw);
}

export async function listMyLocations(limit: number = 100): Promise<DriverLocation[]> {
  const raw = await apiClient.get<any>('/driver-locations/me', { limit });
  return unwrapList<DriverLocation>(raw);
}

export async function listForDriver(driverId: number, limit: number = 100): Promise<DriverLocation[]> {
  const raw = await apiClient.get<any>(`/driver-locations/${driverId}`, { limit });
  return unwrapList<DriverLocation>(raw);
}
